/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M35 3.19C35 1.98 34.015 1 32.8 1c-1.215 0-2.2.98-2.2 2.19v2.191H17.4v-2.19A2.195 2.195 0 0 0 15.2 1c-1.215 0-2.2.98-2.2 2.19v2.191H8.6c-3.645 0-6.6 2.942-6.6 6.571V40.43C2 44.058 4.955 47 8.6 47h30.8c3.645 0 6.6-2.942 6.6-6.571V11.952c0-3.629-2.955-6.571-6.6-6.571H35v-2.19zm6.6 15.334v-6.572c0-1.21-.985-2.19-2.2-2.19H35v2.19c0 1.21-.985 2.19-2.2 2.19-1.215 0-2.2-.98-2.2-2.19v-2.19H17.4v2.19c0 1.21-.985 2.19-2.2 2.19-1.215 0-2.2-.98-2.2-2.19v-2.19H8.6c-1.215 0-2.2.98-2.2 2.19v6.572h35.2zm-35.2 4.38h35.2V40.43c0 1.21-.985 2.19-2.2 2.19H8.6c-1.215 0-2.2-.98-2.2-2.19V22.905z"/>'
  }
})
